module.exports = "/static/assets/8e7cb60d08d6316d55de80f880f1957c.gif";